<template>
  <div class="fbar">
    <div class="fbar__main">

      <transition name="fade-up">
        <div class="fbar__search-input" v-show="searchInputShown" :class="{'hidden': this.$store.state.menuShown}">
          <input type="text" v-model="filterSearchTerm" placeholder="Search meals">
          <button @click="clearSearch" type="button" name="button">
            <img src="../assets/icon-close-tag.svg" alt="">
          </button>
        </div>
      </transition>

      <transition name="fade-up">
        <div class="fbar__filter-dropdown" v-if="!this.searchInputShown" :class="{'hidden': this.$store.state.menuShown}">
          <div ref="filterBtn" class="fbar__label" @click="toggleFilterMenu" :class="{'active': filterMenuShown}">
            <img class="icon-filters" src="../assets/icon-filters.svg" alt="Filters">
            <span class="filter-label">Filtering</span>
            <svg class="filter-chevron" :class="{'menu-open': filterMenuShown }" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 5.49996L0.75 10.2631L0.75 0.736816L6 5.49996Z" fill="#66BC29"/>
            </svg>
          </div>
          <transition name="fade-up">
            <div v-closable="{exclude: ['filterBtn'], handler: 'onClose'}" class="fbar__filters" v-show="filterMenuShown">
              <div class="fbar__filters-row">
                <label class="radio-btn">
                  <input type="radio" v-model="diets" value="All">
                  <span class="radio-btn__label">All Diets</span>
                </label>

                <label class="radio-btn">
                  <input type="radio" v-model="diets" value="Vegetarian">
                  <span class="radio-btn__label">Vegetarian</span>
                </label>

                <label class="radio-btn">
                  <input type="radio" v-model="diets" value="Vegan">
                  <span class="radio-btn__label">Vegan</span>
                </label>
              </div>

              <div class="fbar__filters-row">
                <label class="radio-btn">
                  <input type="radio" v-model="meals" value="All">
                  <span class="radio-btn__label">All Meals</span>
                </label>

                <label class="radio-btn">
                  <input type="radio" v-model="meals" value="Breakfast">
                  <span class="radio-btn__label">Breakfast</span>
                </label>

                <label class="radio-btn">
                  <input type="radio" v-model="meals" value="Lunch/Dinner">
                  <span class="radio-btn__label">Lunch/Dinner</span>
                </label>
              </div>
            </div>
          </transition>
        </div>
      </transition>

      <transition name="fade-up">
        <div class="fbar__sorting-dropdown" v-if="!this.searchInputShown" :class="{'hidden': this.$store.state.menuShown}">
          <div ref="sortBtn" class="sorting-label" @click="toggleSortDropdown" :class="{'active': sortingDropdownShown}">
            <div class="" v-if="this.sortBy == 'Alphabetical'">
              A<span><img src="../assets/icon-sort.svg" alt=""></span>Z
            </div>
            <span class="selected-icon" v-if="this.sortBy == 'Impact-low-high'"><img src="../assets/icon-impact.svg" alt=""></span>
            <span class="selected-icon" v-if="this.sortBy == 'Impact-high-low'"><img class="icon-reversed" src="../assets/icon-impact.svg" alt=""></span>
            <span class="txt">Sorting</span>
            <svg class="filter-chevron" :class="{'menu-open': sortingDropdownShown }" width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 5.49996L0.75 10.2631L0.75 0.736816L6 5.49996Z" fill="#66BC29"/>
            </svg>
          </div>

          <transition name="fade-up">
            <div v-closable="{exclude: ['sortBtn'], handler: 'closeSortingMenu'}" class="fbar__selects" v-show="sortingDropdownShown">
              <label class="radio-btn">
                <input @click="closeSortingMenu" type="radio" v-model="sortBy" value="Alphabetical">
                <span class="radio-btn__label">
                  <span class="sorting-label">A<img src="../assets/icon-sort.svg" alt="">Z</span>
                  <span class="select-txt">Alphabetical</span>
                </span>
              </label>

              <label class="radio-btn">
                <input @click="closeSortingMenu" type="radio" v-model="sortBy" value="Impact-low-high">
                <span class="radio-btn__label">
                  <span class="icon-container"><img src="../assets/icon-impact.svg" alt=""></span>
                  <span class="select-txt">Impact (Low to High)</span>
                </span>
              </label>

              <label class="radio-btn">
                <input @click="closeSortingMenu" type="radio" v-model="sortBy" value="Impact-high-low">
                <span class="radio-btn__label">
                  <span class="icon-container"><img class="icon-reversed" src="../assets/icon-impact.svg" alt=""></span>
                  <span class="select-txt">Impact (High to Low)</span>
                </span>
              </label>
            </div>
          </transition>
        </div>
      </transition>


      <div class="fbar__search" :class="{'hidden': this.$store.state.menuShown}">
        <button type="button" name="button" @click="enableSearch">
          <img src="../assets/icon-search.svg" alt="">
        </button>
      </div>

      <GlobalNav />
    </div>

    <div class="fbar__tags" v-if="this.diets != 'All' || this.meals != 'All'" :class="{shown: !this.searchInputShown}">
      <button v-if="this.diets != 'All' && !this.searchInputShown" class="fbar__tag" type="button" name="button" @click="clearFilter('diets')">
        {{ this.diets }}
        <img src="../assets/icon-close-tag.svg" alt="">
      </button>

      <button v-if="this.meals != 'All' && !this.searchInputShown" class="fbar__tag" type="button" name="button" @click="clearFilter('meals')">
        {{ this.meals }}
        <img src="../assets/icon-close-tag.svg" alt="">
      </button>
    </div>
  </div>
</template>

<script>
// imported from
// https://medium.com/@Taha_Shashtari/an-easy-way-to-detect-clicks-outside-an-element-in-vue-1b51d43ff634

import Vue from 'vue'
// This variable will hold the reference to
// document's click handler
let handleOutsideClick

Vue.directive('closable', {
  bind (el, binding, vnode) {
    // Here's the click/touchstart handler
    // (it is registered below)
    handleOutsideClick = (e) => {
      e.stopPropagation()
      // Get the handler method name and the exclude array
      // from the object used in v-closable
      const { handler, exclude } = binding.value
      // This variable indicates if the clicked element is excluded
      let clickedOnExcludedEl = false
      exclude.forEach(refName => {
        // We only run this code if we haven't detected
        // any excluded element yet
        if (!clickedOnExcludedEl) {
          // Get the element using the reference name
          const excludedEl = vnode.context.$refs[refName]

          // this line was added because if you v-if/else hide an element then it would throw an error about excludedEl being undefined.
          if (excludedEl) {
            // See if this excluded element
            // is the same element the user just clicked on
            clickedOnExcludedEl = excludedEl.contains(e.target)
          }

        }
      })
      // We check to see if the clicked element is not
      // the dialog element and not excluded
      if (!el.contains(e.target) && !clickedOnExcludedEl) {
        // If the clicked element is outside the dialog
        // and not the button, then call the outside-click handler
        // from the same component this directive is used in
        vnode.context[handler]()
      }
    }
    // Register click/touchstart event listeners on the whole page
    document.addEventListener('click', handleOutsideClick)
    document.addEventListener('touchstart', handleOutsideClick)
  },
  unbind () {
    // If the element that has v-closable is removed, then
    // unbind click/touchstart listeners from the whole page
    document.removeEventListener('click', handleOutsideClick)
    document.removeEventListener('touchstart', handleOutsideClick)
  }
})

import GlobalNav from '@/components/GlobalNav'

export default {
  name: 'FilterBar',
  components: {
    GlobalNav
  },
  data() {
    return {
      filterMenuShown: false,
      sortingDropdownShown: false,
      searchInputShown: false
    }
  },
  methods: {
    toggleFilterMenu() {
      this.filterMenuShown = !this.filterMenuShown
    },
    clearFilter(filter) {
      if (filter == 'diets') {
        this.diets = 'All'
      } else if (filter == 'meals') {
        this.meals = 'All'
      }
    },
    onClose() {
      this.filterMenuShown = false
    },
    toggleSortDropdown() {
      this.sortingDropdownShown = !this.sortingDropdownShown
    },
    closeSortingMenu() {
      this.sortingDropdownShown = false
    },
    enableSearch() {
      this.searchInputShown = true
      this.$store.commit('Meals/SEARCHING', this.searchInputShown)
    },
    clearSearch() {
      this.searchInputShown = false
      this.$store.commit('Meals/UPDATE_FILTER_SEARCH_TERM', '')
      this.$store.commit('Meals/SEARCHING', this.searchInputShown)
    }
  },
  computed: {
    filterSearchTerm: {
     get () {
       return this.$store.state.Meals.filterSearchTerm
     },
     set(value) {
       this.$store.commit('Meals/UPDATE_FILTER_SEARCH_TERM', value)
     }
   },
   diets: {
     get() {
       return this.$store.state.Meals.diets
     },
     set(value) {
       this.$store.commit('Meals/UPDATE_DIET_TYPE', value)
     }
   },
   meals: {
     get() {
       return this.$store.state.Meals.meals
     },
     set(value) {
       this.$store.commit('Meals/UPDATE_MEAL_TYPE', value)
     }
   },
   sortBy: {
     get() {
       return this.$store.state.Meals.sortBy
     },
     set(value) {
       this.$store.commit('Meals/UPDATE_SORTING', value)
     }
   }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../assets/styles/vars';
  .fade-enter-active, .fade-leave-active {
    transition: all 0.3s ease-out;
    top: 100%;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
    top: 120%;
  }
  .fade-up-enter-active, .fade-up-leave-active {
    transform: translate3d(0, 0, 0);
    transition: all 0.3s ease-out;
  }
  .fade-up-enter, .fade-up-leave-to {
    transform: translate3d(0, 20px, 0);
    opacity: 0;
  }

  // .fade-up-enter {
  //   opacity: 0;
  //   // transform: translateY(50%);
  //   transform: translate3d(0, 20%, 0);
  // }
  // .fade-up-enter-to {
  //   opacity: 1;
  //   // transform: translateY(0);
  //   transform: translate3d(0, 0, 0);
  //   transition: all 0.3s ease-out;
  // }
  //
  // .fade-up-leave {
  //   opacity: 1;
  //   // transform: translateY(0);
  //   transform: translate3d(0, 0, 0);
  // }
  //
  // .fade-up-leave-to {
  //   opacity: 0;
  //   // transform: translateY(-50%);
  //   transform: translate3d(0, -20, 0);
  //   transition: all 0.3s ease-out;
  // }

  .filter-chevron {
    transform: rotate(90deg);
    transition: all 0.4s ease-out;
    &.menu-open {
      transform: rotate(-90deg);
      transition: all 0.4s ease-out;
    }
  }

  .filter-label {
    font-family: $fPrimary;
    font-weight: $fwSemiBold;
    font-size: 14px;
    padding-left: 11px;
    padding-right: 8px;
  }

  .fbar {
    display: flex;
    flex-flow: column;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 24px;
    padding-right: 24px;
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    border-bottom: 1px solid $cGray;
    background: $cWhite;
    z-index: 9;
    @media (min-width: 768px) {
      left: 50%;
      // width: 50%;
      width: 100%;
      position: sticky; // changed from fixed
      padding-left: 40px;
      padding-right: 40px;
    }
    &__main {
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      // position: relative;
      height: 36px;
    }
    &__tags {
      display: flex;
      flex-flow: row wrap;
      &.shown {
        margin-top: 10px;
      }
    }
    &__tag {
      border-radius: 4px;
      background: #F0FAED;
      color: #64AC07;
      font-family: $fPrimary;
      font-weight: $fwSemiBold;
      font-size: 12px;
      line-height: 14px;
      padding: 10px 14px;
      margin-right: 20px;
      border: 0;
      cursor: pointer;
      &:last-of-type {
        margin-right: 0;
      }
      img {
        margin-left: 9px;
      }
    }
    &__label {
      display: flex;
      flex-flow: row;
      align-items: center;
      cursor: pointer;
      &.active {
        color: $cGreen;
      }
      .icon-filters {
        width: 20px;
        // height: 12px;
      }
    }
    &__filter-dropdown {
      padding-right: 16px;
      position: relative;
      display: flex;
    }
    &__filters {
      padding: 16px;
      border-radius: 4px;
      box-shadow: 0px 3px 12px rgba(52, 69, 84, 0.18);
      background: $cWhite;
      position: absolute;
      top: 48px;
      left: 0;
      width: auto;
      // min-width: 320px;
      @media (min-width: 375px) {
        min-width: 320px;
      }
    }
    &__filters-row {
      &:first-of-type {
        border-bottom: 1px solid $cGray;
        padding-bottom: 16px;
      }
      &:last-of-type {
        padding-top: 16px;
      }
      .radio-btn {
        &:hover {
          background:  #F0FAED;
          transition: all 0.4s ease-out;
        }
      }
    }

    &__sorting-dropdown {
      position: relative;
      .sorting-label.active {
        .txt {
          color: $cGreen;
          transform: color 0.2s ease-out;
        }
      }
      .selected-icon {
        width: 27.58px;
        height: 21px;
        img {
          width: auto;
          height: auto;
          &.icon-reversed {
            transform: scaleX(-1);
          }
        }
      }
    }
    &__selects {
      padding: 10px 0;
      border-radius: 4px;
      box-shadow: 0px 3px 12px rgba(52, 69, 84, 0.18);
      background: $cWhite;
      position: absolute;
      top: 48px;
      left: -50px;
      width: 210px;
      display: flex;
      flex-flow: column;
      @media (min-width: 350px) {
        left: -10px;
      }
      @media (min-width: 768px) {
        width: 220px;
        left: -10px;
      }
      .radio-btn {
        width: 100%;
        margin-right: 0;
        input  {
          &:checked + .radio-btn__label, &:hover + .radio-btn__label {
            background: #F0FAED;
            transition: all 0.4s ease-out;
          }
          &:hover {
            background: red;
          }
        }
      }
      .radio-btn__label {
        width: 100%;
        min-height: 40px;
        display: flex;
        align-items: center;
        .sorting-label {
          margin-right: 10px;
        }
        .icon-container {
          margin-right: 10px;
          width: 28px;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .select-txt {
          font-family: $fPrimary;
          font-weight: $fwSemiBold;
          font-size: 12.5px;
          color: $cBlack;
        }
        .icon-reversed {
          transform: scaleX(-1);
        }
      }
    }

    &__search {
      margin-left: auto;
      margin-right: 16px;
      @media (min-width: 768px) {
        margin-right: 0;
      }
      button {
        background: none;
        border: 0;
        cursor: pointer;
        width: 24px;
        height: 24px;
      }
    }
    &__search-input {
      position: absolute;
      top: 50%;
      left: 24px;
      transform: translateY(-50%);
      height: 36px;
      border-radius: 3px;
      width: calc(80% - 60px);
      @media (min-width: 768px) {
        left: 40px;
      }
      input {
        background: #F4F7F8;
        border: none;
        padding-top: 9px;
        padding-bottom: 9px;
        padding-left: 14px;
        padding-right: 24px;
        width: 100%;
        position: relative;
        border-radius: 3px;
        height: 36px;
        &::placeholder {
          font-family: $fPrimary;
          font-size: 13px;
          font-weight: $fwMed;
        }
      }
      button {
        position: absolute;
        top: 50%;
        right: 13px;
        transform: translateY(-50%);
        background: none;
        border: none;
        cursor: pointer;
        line-height: 0.6;
      }
    }
  }
  .radio-btn {
    position: relative;
    display: inline-block;
    border-radius: 4px;
    margin-right: 10px;
    cursor: pointer;
    &:last-of-type {
      margin-right: 0;
    }
    input {
      opacity: 0;
      position: absolute;
      outline: none;
      z-index: -1;
      &:checked + .radio-btn__label {
        background: #F0FAED;
        color: $cGreen;
        transition: all 0.4s ease-out;
      }
    }
    &__label {
      position: relative;
      display: inline-block;
      padding: 10px;
      border-radius: 4px;
      font-size: 12.5px;
      font-weight: $fwSemiBold;
    }
  }

  .sorting-label {
    font-family: $fSecondary;
    font-weight: $fwSemiBold;
    font-size: 14px;
    line-height: 21px;
    text-transform: uppercase;
    color: $cGreen;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 10.5px;
      margin-left: 1px;
      margin-right: 2.5px;
      margin-top: 2px;
    }
    .txt {
      font-family: $fPrimary;
      font-weight: $fwSemiBold;
      color: $cBlack;
      text-transform: none;
      padding-left: 10px;
      padding-right: 8px;
      transform: color 0.2s ease-out;
    }
  }
</style>
